// extracted by mini-css-extract-plugin
module.exports = {"root":"DerkWKNk","content":"yvmS2p3u"};